import { render, staticRenderFns } from "./CoreLogin.vue?vue&type=template&id=ed55248c"
import script from "./CoreLogin.vue?vue&type=script&lang=js"
export * from "./CoreLogin.vue?vue&type=script&lang=js"
import style0 from "./CoreLogin.vue?vue&type=style&index=0&id=ed55248c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports